@if (!isFromMobileApp) {
@if (displayExtraFooter && iosUrl && androidUrl) {
<div class="app-container"
     fxLayout="column"
     fxLayoutAlign="center center">
    <div fxLayout="row"
         fxLayoutGap="1rem">
        <div fxFlexAlign="left">
            <a href="{{iosUrl}}"
               target="_blank">
                <img src="./assets/imgs/login/apple-store.png"
                     alt="apple-store-logo">
            </a>
        </div>
        <div fxFlexAlign="left">
            <a href="{{androidUrl}}"
               target="_blank">
                <img class="google-download"
                     src="./assets/imgs/login/google-play-store.png"
                     alt="google-play-store-logo">
            </a>
        </div>
    </div>
</div>
<mat-divider class="full-width-container"></mat-divider>
}
@if (showDisclaimer && !isLockerLiteUser) {
<div class="disclaimer-container"
     ngClass.lt-sm="small-padding-container"
     fxLayout="column"
     fxLayoutAlign="center center"
     fxLayoutGap="1rem">
    @for (disclaimer of companyDisclaimerMessage; track disclaimer) {
    <span class="disclaimer-line-container"
          (click)="onDisclaimerClick($event)"
          [innerHTML]="disclaimer">
    </span>
    }
</div>
}
<footer [ngClass]="isRegistrationFooter && isValuePropositionPage ? 'bottom-registration-bar' : 'bottom-nav-bar'"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="space-around center"
        fxLayoutGap="64px"
        fxLayoutGap.xs="10px">
    @if (isValuePropositionPage) {
    <div class="registration-footer"
         fxLayout="column"
         fxLayoutGap="1em"
         fxLayoutAlign="center center">
        <div class="registration-bottom-footer"
             fxFlex="1 1 auto"
             fxLayoutAlign="center center">
            <div fxFlex="1 1 auto"
                 fxLayout="row"
                 fxLayout.xs="column"
                 fxLayoutAlign="space-between center"
                 fxLayoutGap="1em">
                <div fxLayout="row"
                     fxLayoutGap="1em">
                    <a class="pointer-cursor white-container"
                       id="footer-privacy-policy"
                       href="https://finlocker.com/privacy-policy/"
                       target="_blank"
                       (click)="clickEvent('Privacy Policy')">Privacy Policy</a>
                    <div>|</div>
                    <a class="pointer-cursor white-container"
                       id="footer-terms-of-service"
                       href="https://finlocker.com/terms-of-service/"
                       target="_blank"
                       (click)="clickEvent('Terms of Service')">Terms of Service</a>
                    <div>|</div>
                    <a class="pointer-cursor white-container"
                       id="footer-legal"
                       href="https://www.finlocker.com/security/"
                       target="_blank"
                       (click)="clickEvent('Security')">Security</a>
                    <div>|</div>
                    <a class="pointer-cursor white-container"
                       id="footer-support"
                       href="{{freshDeskUrl}}"
                       target="_blank"
                       (click)="clickEvent('Support')">Support</a>
                </div>
                @if(theme?.companyNmls) {
                <div class="nmls-container"
                     fxLayoutAlign="center center">
                    {{ theme.titleBar }} NMLS# {{ theme.companyNmls }}
                </div>
                }
                <div fxLayoutAlign.xs="center center">&copy; {{now | date:'yyyy'}} FinLocker, Inc. All rights reserved.
                </div>
            </div>
        </div>
    </div>
    } @else {
    @if (isOldFooter || isLockerLiteUser) {
    @if (theme && theme?.poweredByImageUrl?.length > 1) {
    <div class="powered-by-container"
         [ngClass.lt-sm]="'column-container'"
         fxFlex="1 1 35"
         fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutAlign.xs="center">
        <img [src]="theme.poweredByImageUrl"
             alt="footer-logo"
             class="footer-logo">
    </div>
    }
    <div class="old-footer-container"
         fxFlex="1 1 50"
         fxLayout="row"
         fxLayoutAlign.xs="center">
        <div fxFlex="grow"
             fxFlex.xs="initial"
             class="bottom-nav"
             fxLayout="column"
             fxLayoutAlign="space-between center"
             fxLayoutGap="0.5rem">
            <ul fxLayout="row"
                fxLayoutAlign="center center">
                <li>
                    <div fxLayout="row"
                         class="pointer-cursor"
                         fxLayoutAlign="start center"
                         fxLayoutGap="8px"
                         (click)="freshdeskLogin()">
                        <span>Support</span>
                    </div>
                </li>
                <li>
                    <a href="https://finlocker.com/terms-of-service/"
                       target="_blank"
                       GACtaLabel="footer-cta|Terms of Service"
                       GAClickEventUnAuthenticated>Terms of Service</a>
                </li>
                <div class="list"
                     fxHide="true"
                     fxShow.gt-sm="true">
                    <li>
                        <a href="https://finlocker.com/privacy-policy/"
                           target="_blank"
                           GACtaLabel="footer-cta|Privacy Policy"
                           GAClickEventUnAuthenticated>Privacy Policy</a>
                    </li>
                    <li>
                        <a href="https://www.finlocker.com/security/"
                           target="_blank"
                           GACtaLabel="footer-cta|Security"
                           GAClickEventUnAuthenticated>Security</a>
                    </li>
                    <li>
                        <div class="pointer-cursor"
                             (click)="openCancellationModal()">Forget Me</div>
                    </li>
                </div>
            </ul>
            <ul fxHide="true"
                fxShow.lt-md="true"
                fxLayoutAlign="center center">
                <li>
                    <a href="https://www.finlocker.com/?page_id=510"
                       target="_blank"
                       GACtaLabel="footer-cta|Privacy Policy"
                       GAClickEventUnAuthenticated>Privacy Policy</a>
                </li>
                <li>
                    <a href="https://www.finlocker.com/security/"
                       target="_blank"
                       GACtaLabel="footer-cta|Security"
                       GAClickEventUnAuthenticated>Security</a>
                </li>
                <li>
                    <div class="pointer-cursor"
                         (click)="openCancellationModal()"> Forget Me</div>
                </li>
            </ul>
            @if(theme?.companyNmls) {
            <div class="nmls-container"
                 fxLayoutAlign="center center">
                {{ theme.titleBar }} NMLS# {{ theme.companyNmls }}
            </div>
            }
            <div ngClass.lt-sm="text-align-center"
                 fxLayoutAlign="center center">&copy; {{now | date:'yyyy'}} FinLocker, Inc. All rights reserved.
            </div>
        </div>
    </div>
    } @else {
    <div fxLayout="column">
        <div class="new-footer-container"
             fxLayout="row wrap"
             fxLayoutAlign="space-between start"
             fxHide.lt-sm="true"
             fxShow="true"
             [ngClass.lt-lg]="'small-new-footer-container'">
            <div class="footer-column-container"
                 fxLayout="column"
                 fxLayoutGap="2em">
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-title-container">Credit</span>
                    @if (creditRoute === '/credit-report') {
                    <span class="pointer-cursor"
                          id="footer-credit-score-navigation"
                          (click)="route(creditRoute, 'Credit Score', 'Credit Score')">Credit Score</span>
                    <span class="pointer-cursor"
                          id="footer-credit-report-navigation"
                          (click)="route(creditRoute, 'Credit Report', 'Credit Report')">Credit Report</span>
                    @if (features?.featureCodes?.includes(FeatureCode.CreditCompass)) {
                    <span class="pointer-cursor"
                          id="footer-credit-compass-navigation"
                          (click)="route(creditRoute, 'Credit Compass', 'Credit Compass')">Credit Compass</span>
                    }
                    @if (features?.featureCodes?.includes(FeatureCode.CreditSimulator)) {
                    <span class="pointer-cursor"
                          id="footer-credit-simulator-navigation"
                          (click)="route(creditRoute, 'Credit Simulator', 'Credit Simulator')">Credit Simulator</span>
                    }
                    } @else {
                    <span class="pointer-cursor"
                          id="footer-credit-enrollment-navigation"
                          (click)="route('/credit-enrollment', '', 'Credit Enrollment')">+ Add Credit</span>
                    }
                </div>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-title-container">Finances</span>
                    <span class="pointer-cursor"
                          id="footer-homeownership-budget-navigation"
                          (click)="route('/homeownership-budget', '', 'Homeownership Budget')">Homeownership Budget</span>
                    <span class="pointer-cursor"
                          id="footer-account-enrollment-navigation"
                          (click)="route('/accounts-enrollment', '', 'Add Accounts')">+ Add Accounts</span>
                    @if (financialInstitution && financialInstitution?.length > 0) {
                    <span class="pointer-cursor"
                          id="footer-budget-and-goals-navigation"
                          (click)="route('/budgets', '', 'Legacy Budget')">Legacy Budget</span>
                    <span class="pointer-cursor"
                          id="footer-spending-navigation"
                          (click)="route('/spending', '', 'Spending')">Spending</span>
                    }
                    @if (featuresService.isFeatureEnabled(FeatureCode.MyProperty)) {
                    @if (property?.result?.totalCount > 0) {
                    <span class="pointer-cursor"
                          id="footer-property-navigation"
                          (click)="route('/properties/homes', 'Homes you own', 'Home Value')">Homes you own</span>
                    } @else {
                    <span class="pointer-cursor"
                          id="footer-enroll-property-navigation"
                          (click)="route('/properties/home-enrollment', 'Enroll Property', 'Enroll Property')">+ Enroll Property</span>
                    }
                    }
                </div>
            </div>
            <div class="footer-column-container"
                 fxLayout="column"
                 fxLayoutGap="0.5rem">
                <span class="footer-title-container">Readiness</span>
                @if (featuresService.isFeatureEnabled(FeatureCode.BuyerVision)) {
                <span class="pointer-cursor"
                      id="footer-verification-overview-navigation"
                      (click)="route('/verification-overview', '', 'BuyerVision and other lender coaching')">BuyerVision and other lender coaching</span>
                }
                <span class="pointer-cursor"
                      id="footer-homeownership-snapshot-navigation"
                      (click)="route('/readiness', '', 'Homeownership Snapshot')">Monthly Payment Planning</span>
                @if (isLenderConnectEnabled()) {
                <span class="pointer-cursor"
                      id="footer-lender-connect-navigation"
                      (click)="route('/lender-connect', '', 'Lender Connect')">Documents to share to your lender</span>
                }
            </div>
            <div class="footer-column-container"
                 fxLayout="column"
                 fxLayoutGap="2em">
                @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch) || featuresService.isFeatureEnabled(FeatureCode.GenAiMarketReport)) {
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-title-container">
                        @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch)) {
                        Properties
                        } @else {
                        Market Report
                        }
                    </span>
                    @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch)) {
                    <span class="pointer-cursor"
                          id="footer-property-saved-properties"
                          (click)="route('/properties', 'Saved Properties', 'Saved Home')">Your Saved
                        Properties</span>
                    <span class="pointer-cursor"
                          id="footer-property-search-navigation"
                          (click)="onPropertySearchClick()">Search for a Property</span>
                    }
                    @if (featuresService.isFeatureEnabled(FeatureCode.GenAiMarketReport)) {
                    <span class="pointer-cursor"
                          id="footer-market-report-navigation"
                          (click)="route('/your-market-report', '', 'footer_market_report_clicked')">Your Market Report</span>
                    }
                </div>
                }
                <div class="footer-column-container"
                     fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-title-container">Tools & Education</span>
                    <span class="pointer-cursor"
                          id="footer-affordability-calculators-navigation"
                          (click)="route('/calculators/affordability-calculator', '', 'Affordability Calculator')">Affordability</span>
                    @if (featuresService.isFeatureEnabled(FeatureCode.Education)) {
                    <span class="pointer-cursor"
                          id="footer-education-navigation"
                          (click)="route('/education', '', 'Education')">Education</span>
                    }
                </div>
            </div>
            <div class="footer-column-container"
                 fxLayout="column"
                 fxLayoutGap="0.5rem">
                <span class="footer-title-container">Support</span>
                <span class="pointer-cursor"
                      id="footer-support-ticket-navigation"
                      (click)="freshdeskLogin()">Create a Support Ticket</span>
                <span class="pointer-cursor"
                      id="footer-contact-navigation"
                      (click)="route('/contact-lender', '', 'Contact Lender')">Contact</span>
            </div>
        </div>
        <mat-accordion class="dashboard-accordion-container"
                       fxLayout="column"
                       fxLayoutGap="1em"
                       fxHide="true"
                       fxShow.lt-sm="true">
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        Credit
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                @if (creditRoute === '/credit-report') {
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-credit-score-navigation"
                          (click)="route(creditRoute, 'Credit Score', 'Credit Score')">Credit Score</span>
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-credit-report-navigation"
                          (click)="route(creditRoute, 'Credit Report', 'Credit Report')">Credit Report</span>
                    @if (features?.featureCodes?.includes(FeatureCode.CreditCompass)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-credit-compass-navigation"
                          (click)="route(creditRoute, 'Credit Compass', 'Credit Compass')">Credit Compass</span>
                    }
                    @if (features?.featureCodes?.includes(FeatureCode.CreditSimulator)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-credit-simulator-navigation"
                          (click)="route(creditRoute, 'Credit Simulator', 'Credit Simulator')">Credit Simulator</span>
                    }
                </div>
                } @else {
                <span class="pointer-cursor white-container"
                      id="footer-credit-enrollment-navigation"
                      (click)="route('/credit-enrollment', '', 'Credit Enrollment')">+ Add Credit</span>
                }
            </mat-expansion-panel>
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        Finances
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-homeownership-budget-navigation"
                          (click)="route('/homeownership-budget', '', 'Homeownership Budget')">Homeownership Budget</span>
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-account-enrollment-navigation"
                          (click)="route('/accounts-enrollment', '', 'Add Accounts')">+ Add Accounts</span>
                    @if (financialInstitution && financialInstitution?.length > 0) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-budget-and-goals-navigation"
                          (click)="route('/budgets', '', 'Legacy Budget')">Legacy Budget</span>
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-spending-navigation"
                          (click)="route('/spending', '', 'Spending')">Spending</span>
                    }
                    @if (featuresService.isFeatureEnabled(FeatureCode.MyProperty)) {
                    @if (property?.result?.totalCount > 0) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-property-navigation"
                          (click)="route('/properties/homes', 'Homes you own', 'Home Value')">Homes you own</span>
                    } @else {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-enroll-property-navigation"
                          (click)="route('/properties/home-enrollment', 'Enroll Property', 'Enroll Property')">+ Enroll Property</span>
                    }
                    }
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        Readiness
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    @if (featuresService.isFeatureEnabled(FeatureCode.BuyerVision)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-verification-overview-navigation"
                          (click)="route('/verification-overview', '', 'Verification Overview')">BuyerVision and other lender coaching</span>
                    }
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-homeownership-snapshot-navigation"
                          (click)="route('/readiness', '', 'Homeownership Snapshot')">Monthly Payment Planning</span>
                    @if (isLenderConnectEnabled()) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-lender-connect-navigation"
                          (click)="route('/lender-connect', '', 'Lender Connect')">Documents to share to your lender</span>
                    }
                </div>
            </mat-expansion-panel>
            @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch) || featuresService.isFeatureEnabled(FeatureCode.GenAiMarketReport)) {
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch)) {
                        Properties
                        } @else {
                        Market Report
                        }
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    @if (featuresService.isFeatureEnabled(FeatureCode.PropertySearch)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-property-saved-properties"
                          (click)="route('/properties', 'Saved Properties', 'Saved Home')">Your Saved Properties</span>
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-property-search-navigation"
                          (click)="onPropertySearchClick()">Search for a Property</span>
                    }
                    @if (featuresService.isFeatureEnabled(FeatureCode.GenAiMarketReport)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-market-report-navigation"
                          (click)="route('/your-market-report', '', 'footer_market_report_clicked')">Your Market Report</span>
                    }
                </div>
            </mat-expansion-panel>
            }
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        Tools & Education
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-affordability-calculators-navigation"
                          (click)="route('/calculators/affordability-calculator', '', 'Affordability Calculator')">Affordability</span>
                    @if (featuresService.isFeatureEnabled(FeatureCode.Education)) {
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-education-navigation"
                          (click)="route('/education', '', 'Education')">Education</span>
                    }
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="primary-background-container no-shadow-container"
                                 hideToggle="true"
                                 #example>
                <mat-expansion-panel-header class="accordion-header">
                    <mat-panel-title class="white-container bold-container">
                        Support
                    </mat-panel-title>
                    <div class="mat-drop-down-button">
                        <mat-icon>{{example.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                    </div>
                </mat-expansion-panel-header>
                <div fxLayout="column"
                     fxLayoutGap="0.5rem">
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-support-ticket-navigation"
                          (click)="freshdeskLogin()">Create a Support Ticket</span>
                    <span class="footer-item-container pointer-cursor white-container"
                          id="footer-contact-navigation"
                          (click)="route('/contact-lender', '', 'Contact Lender')">Contact</span>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        @if(theme?.companyNmls) {
        <div class="nmls-container bottom-margin-container"
             fxLayoutAlign="center center">
            {{ theme.titleBar }} NMLS# {{ theme.companyNmls }}
        </div>
        }
    </div>
    }
    }
</footer>
}
